import React from 'react';

import cx from 'classnames';
import { Link } from 'react-router-dom';

import useStyles from './style';

interface TabItemProps {
  label: string;
  value?: string;
  selectedItem?: string;
  handleSelect?: Function;
  link?: string;
}

const TabItem: React.FC<TabItemProps> = ({
  label,
  value,
  link,
  handleSelect,
  selectedItem,
  ...rest
}) => {
  const classes = useStyles();
  const isSelected = value === selectedItem;

  return link ? (
    <Link
      data-testid={rest['data-testid']}
      to={link}
      className={cx(classes.tabItem, isSelected && classes.active)}
      data-selected={isSelected}
    >
      {label}
    </Link>
  ) : (
    <div
      data-testid={rest['data-testid']}
      className={cx(classes.tabItem, isSelected && classes.active)}
      onClick={() => handleSelect && handleSelect(value)}
      data-selected={isSelected}
    >
      {label}
    </div>
  );
};

export default TabItem;
